module.exports = __webpack_public_path__ + "img/Mali.515f45a8.svg";